import { NgModule } from '@angular/core';
import { OpencamComponent } from './opencam.component';

@NgModule({
  declarations: [OpencamComponent],
  imports: [
  ],
  exports: [OpencamComponent]
})
export class OpencamModule { }
